import {mapGetters, mapMutations} from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtMortgage from '@/common/components/mvtmortgage/mvt-mortgage.vue';
import propertyFuncs from '@/common/utilities/propertyFuncs';
import dppCtaCard from '@/dpp/components/dppctacard/dpp-ctacard.vue';

export default {
    name: 'propertyMortgage',
    components: {
        mvtCollapse,
        mvtMortgage,
        dppCtaCard,
    },
    inject: ['$eventBus'],
    props: ['disableCollapse', 'options', 'isActive'],
    data() {
        return {
            description: '',
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
        getPopUpTitle() {
            return this.options.showNewTitle ? `Thanks! We will call you soon. <br/>Be prepared to make offers, get preapproved today.` : `Get preapproved for a mortgage on this property`;
        },
        getIsActive() {
            if (this.isActive === false) {
                return false;
            }
            let calcSection = propertyFuncs.getDppSectionPreferences('paymentCalc');
            return calcSection ? calcSection['isOpen'] : true;
        },
        getSectionTitle() {
            const key = !this.dpp.isActive ? 'dpp.propertyMortgage.homeownershipcostcalcWithAddress' :
                'dpp.propertyMortgage.paymentCalcWithAddress';

            return this.molang(key, {streetAddress: this.dpp.geo.address});
        },
    },
    methods: {
        ...mapMutations('dpp', ['updateMortgagePerMonth', 'updateMonthTotal']),
        ...mapMutations('glb', ['updatePrevHotlead']),
        ...mapGetters('glb', ['getComplianceMethod']),
        showDataSource() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
        monthTotalChanged(val) {
            this.updateMonthTotal(val);
        },
        loanPerMonthChanged(val) {
            this.updateMortgagePerMonth(val);
        },
        updateDescription(text) {
            this.description = text;
        },
        openMortgageComponent() {
            this.$refs.mortgageComponent.toggleMortgageSection(true);
            this.updatePaymentSectionStatus(true);
        },
        closePaymentSection() {
            this.updatePaymentSectionStatus(false);
        },
        updatePaymentSectionStatus(status) {
            let data = {
                section: 'paymentCalc',
                details: [{ key: 'isOpen', value: status }],
            };
            propertyFuncs.setDppSectionPreferences(data);
        },
        show3rdPartyForm() {
            var isLandMobile = this.dpp.houseRealStatus === 'ACTIVE' && this.dpp.price <= 100000 && ['LAND', 'MOBILE'].includes(this.dpp.propertyType);
            let id = !this.dpp.isActive ? 'inactivecalculate' : 'calculatepayment';
            let url = this.dpp.isActive ? (isLandMobile ? 'prequalifylandmobile' : 'preapprove') : 'refinance';
            this.$eventBus.$emit('eventbus-pop-cpc3way', { id, url });
        },
        openHotleadForm() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Find a realtor',
                    hotleadType: 'calcpaymentagentform',
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    buttonText: 'Meet an agent',
                    showComment: true,
                    hideVeteran: true,
                },
            });
            this.$eventBus.$emit('ga', { en: 'calcpaymentagentform' });
        },
    },
    mounted() {
        let calcSection = propertyFuncs.getDppSectionPreferences('paymentCalc');
        if (!calcSection || !calcSection.hasOwnProperty('isOpen')) {
            this.updatePaymentSectionStatus(true);
        }
        if (this.options && this.options.showRefinance) {
            this.updatePrevHotlead({
                trigger: this.$options.name,
            });
            this.$eventBus.$once('eventbus-dialog-close', () => {
                this.$eventBus.$emit('eventbus-hotlead-step', { trigger: this.$options.name });
            });
        }
    },
};
